"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import ISubject from "@/interfaces/subject.interface";
import subjectService from "@/services/subject.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<ISubject | null>;

export type Props = ByIdRequestProps;

type UseSwrGetSubjectByIdParams = [string, number];

const useGetSubjectById = ({ _id }: Props): Return => {
  const fetcher = useSWR<ISubject, Error, UseSwrGetSubjectByIdParams | null>(
    _id ? [SWR_KEYS.getSubjectById, _id] : null,
    ([, subjectId]) => subjectService.getById(subjectId),
    { revalidateOnFocus: false, shouldRetryOnError: false, errorRetryCount: 0 }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetSubjectById;
